<template>
  <div>
    <liquidator-judicial-guard-form
      :form-model="formModel"
      :required="required"
    ></liquidator-judicial-guard-form>
  </div>
</template>

<script>
import LiquidatorJudicialGuardForm from './forms/liquidator-judicial-guard-form.vue';
export default {
  components: { LiquidatorJudicialGuardForm },
  inject: ['$validator'],
  props: ['formModel', 'required'],
};
</script>
